export default __webpack_public_path__ + "static/media/dials.37641ace.svg";